import React, { useCallback } from "react";
import LogDisplay from "components/Interactions/LogDisplay";
import { directMailLogAPI } from "api/Interactions/DirectMailAPI";
import { Column } from "components/Data/DataDisplays/GenericTable";

interface DirectMailBottomDrawerProps {
  directMailId: number;
}

const DirectMailBottomDrawer: React.FC<DirectMailBottomDrawerProps> = ({ directMailId }) => {
  const fetchLogs = useCallback(() => directMailLogAPI.getAllByParentId(directMailId), [directMailId]);

  const columns: Column<any>[] = [
    { field: "timestamp", label: "Timestamp", type: "datetime"},
    { field: "first_name", label: "First Name", type: "text" },
    { field: "last_name", label: "Last Name", type: "text" },
    { field: "street_address", label: "Street Address", type: "text" },
    { field: "city", label: "City", type: "text" },
    { field: "country", label: "Country", type: "text" },
    { field: "success", label: "Success", type: "boolean" },
  ];

  return (
    <LogDisplay
      fetchLogs={fetchLogs}
      columns={columns}
      title="Direct Mail Logs"
    />
  );
};

export default DirectMailBottomDrawer;
